import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Bookmark } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

export default function UniversityCard({ u, index = 0, saved = false, onToggleSave = null }) {
  return (
    <FadeUp delay={(index % 4) * 0.08} className="h-full">
      <Link
        to={`/universities/${u.slug}`}
        data-testid={`university-card-${u.slug}`}
        className="group relative flex flex-col h-full bg-white border border-border hover:border-gold hover:-translate-y-1 hover:shadow-lg transition-[transform,border-color,box-shadow] duration-500"
      >
        {onToggleSave && (
          <button
            data-testid={`save-university-${u.slug}`}
            aria-label={saved ? "Remove from saved" : "Save university"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onToggleSave(u.slug);
            }}
            className={`absolute top-3 right-3 z-10 p-2.5 border backdrop-blur-sm transition-colors duration-300 ${
              saved
                ? "bg-gold border-gold text-navy"
                : "bg-navy/50 border-white/30 text-white hover:bg-gold hover:border-gold hover:text-navy"
            }`}
          >
            <Bookmark className="h-4 w-4" fill={saved ? "currentColor" : "none"} />
          </button>
        )}
        <div className="overflow-hidden max-h-48 relative">
          <img
            src={u.image}
            alt={u.name}
            loading="lazy"
            className="h-48 w-full object-cover saturate-[0.75] transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-navy/20 group-hover:bg-navy/10 transition-colors duration-500" />
        </div>
        <div className="flex flex-col flex-1 p-6">
          <p className="flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-navy/50">
            <MapPin className="h-3 w-3 text-gold" /> {u.city}, {u.state}
          </p>
          <h3 className="mt-3 font-serif text-2xl font-medium text-navy leading-snug">{u.name}</h3>
          <p className="mt-3 text-sm text-navy/60 leading-relaxed flex-1">{u.descriptor}</p>
          <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-navy group-hover:text-gold transition-colors duration-300">
            Learn More <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </Link>
    </FadeUp>
  );
}
